import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../../service/events/dashboard.service';
import { StockApiService } from '../../../service/api/stock-api.service';
import { Router } from '@angular/router';
import { RequestHandler } from '../../../service/OffService/request-handler';
import { BaseView } from '../../base-view';
import { environment } from 'src/environments/environment';

import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
    InputType,
} from '@fitogest/reactive-form-builder/interfaces';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { StockageModel } from 'src/app/models/stock/stokage.model';

@Component({
  selector: 'app-salidas',
  standalone: false,
  templateUrl: './salidas.component.html',
  styleUrls: ['./salidas.component.scss']
})
export class SalidasComponent
  extends BaseView<StockageModel>
  implements OnInit
{
  public fincaName = environment.features.fincaName;

  public fincasName = environment.features.fincasName;

  public getRequest: RequestHandler<StockageModel[]> =
    this.stockApi.salidas.GET;

  public deleteRequest: RequestHandler<StockageModel> =
    this.stockApi.salidas.DELETE;

  public readonly serverUrl = environment.serverUrl;

  public formFields: Form<StockageModel> = this.createModalForm(
    FormType.INFORMATIVE
  );

  public cols: ColInterface[] = [
    { field: 'finca_nombre', header: this.fincaName, filter: 'dropdown' },
    { field: 'producto1_nombre', header: 'Producto', filter: 'dropdown' },
    { field: 'fecha', header: 'Fecha', filter: 'calendar' },
    { field: 'unidades', header: 'Unidades', filter: '' },
    { field: 'albaran', header: 'Albarán', filter: '' }
  ];

  constructor(
    public stockApi: StockApiService,
    private dashboardEvents: DashboardService,
    private router: Router
  ) {
    super(dashboardEvents, stockApi.salidas.GET, stockApi.salidas.DELETE);
  }

  ngOnInit() {
    this.dashboardEvents.setSubmenuItem('stock', 'stock-salidas');
  }

  public add() {
    this.router.navigate(['dashboard', 'stock-crear-salida']);
  }

  public edit(data: StockageModel) {
    this.router.navigate(['dashboard', 'stock-editar-salida', data.id]);
  }

  public override show(modal: string, data: StockageModel): void {
    super.show(modal, data);

    this.formFields = this.createModalForm(
      modal === 'delete' ? FormType.DELETION : FormType.INFORMATIVE
    );
  }

  private createModalForm(type: FormType): Form<StockageModel> {
    return {
      name: 'salidas',
      header:
        type === FormType.DELETION ? 'Eliminar salida' : 'Detalle de la salida',
      type,
      sections: this.getModalSections(),
      table: null,
      uploadButton: {
        isEnabled: false,
        label: ''
      },
      signed: false
    };
  }

  private getModalSections(): FormSection<StockageModel>[] {
    return [
      {
        name: '',
        fields: this.getModalFields(),
        width: 12,
        isVisible: true,
        order: 1
      }
    ];
  }

  private getModalFields(): FormField<StockageModel>[] {
    return [
      this.hiddenField('id', 1),
      this.textField('finca_nombre', this.fincaName, 2),
      this.textField('unidades', 'Total de unidades', 3),
      this.emptyField(4),
      this.textField('producto1_nombre', 'Producto', 5),
      this.textField('unidades1', 'Unidades', 6),
      this.textField('lote1', 'Lote', 7),
      this.textField('producto2_nombre', '', 8),
      this.textField('unidades2', '', 9),
      this.textField('lote2', '', 10),
      this.textField('producto3_nombre', '', 11),
      this.textField('unidades3', '', 12),
      this.textField('lote3', '', 13),
      this.textField('albaran', 'Albarán', 14),
      this.textField('fecha', 'Fecha', 15),
      this.textField('tiposalida', 'Tipo', 16),
      this.textField('observaciones', 'Observaciones', 17)
    ];
  }

  private textField(
    name: keyof StockageModel & string,
    label: string,
    order: number
  ): FormField<StockageModel> {
    return {
      name,
      vinculatedFields: undefined,
      label,
      input: {
        type: InputType.TEXT,
        isEditable: false
      },
      width: 4,
      conditions: this.conditions(),
      order
    };
  }

  private emptyField(order: number): FormField<StockageModel> {
    return {
      name: `empty_${order}`,
      vinculatedFields: undefined,
      label: '',
      input: {
        type: InputType.EMPTY,
        isEditable: false
      },
      width: 4,
      conditions: this.conditions({ isRetained: true }),
      order
    };
  }

  private hiddenField(
    name: keyof StockageModel & string,
    order: number
  ): FormField<StockageModel> {
    return {
      name,
      vinculatedFields: undefined,
      label: '',
      input: {
        type: InputType.HIDDEN,
        isEditable: false
      },
      width: 0,
      conditions: this.conditions(),
      order
    };
  }

  private conditions(
    overrides: Partial<FormFieldConditions> = {}
  ): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides
    };
  }
}
